import React from "react";

// Escape regex-special characters so a user-typed keyword is matched literally.
const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

/**
 * Renders `text` with every (case-insensitive) occurrence of `keyword` wrapped
 * in a highlighted <mark>. Falls back to plain text when there is no keyword.
 */
function Highlight({ text, keyword }) {
  const value = text == null ? "" : String(text);
  const term = (keyword || "").trim();

  if (!term) {
    return <>{value}</>;
  }

  const parts = value.split(new RegExp(`(${escapeRegExp(term)})`, "gi"));
  const lowerTerm = term.toLowerCase();

  return (
    <>
      {parts.map((part, index) =>
        part.toLowerCase() === lowerTerm ? (
          <mark key={index} className="bg-yellow-200 text-inherit rounded-[2px]">
            {part}
          </mark>
        ) : (
          <React.Fragment key={index}>{part}</React.Fragment>
        )
      )}
    </>
  );
}

export default Highlight;
